<div class="container">
  @if (!hasTravelActive) {
    <div>
      <mat-horizontal-stepper linear="true" #stepper>
        <mat-step [completed]="equipmentSelect">
          <ng-template class="font" matStepLabel>Selección de Equipo</ng-template>
          <app-equipment-table
            class="w-100"
            (clickRow)="clickRowEquipment($event)"
            [equipment]="equipment"
            >
          </app-equipment-table>
        </mat-step>
        <mat-step>
          <ng-template class="font" matStepLabel>Selección viaje</ng-template>
          <app-button-label [labelsEdit]="labelsRouter"> </app-button-label>
          <div class="d-flex flex-column align-items-center">
            <data-table
              class="w-100"
              [title]=""
              [columns]="routeColumnsTable"
              [configuration]="routeConfigurationTable"
              [params]="[{ id: 'active',  value: 1 }]"
              [url]="urlGetRoutes"
              (clickRow)="clickRowRoute($event)"
            ></data-table>
            <button
              matStepperNext
              style="width: 70%; margin: 15px 0 15px 0"
              color="primary"
              class="button-save mat-elevation-z5"
              mat-raised-button
              (click)="initRoute()"
              >
              Iniciar ruta
            </button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  } @else {
    <div class="d-flex justify-content-around mb-4 align-items-center">
      <app-button-label [labelsEdit]="labelsTravelHistory"> </app-button-label>
      <div class="d-flex flex-column mt-5">
        <button class="mb-4" mat-mini-fab color="warn" (click)='cancelTravel()' matTooltip="Eliminar viaje">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </div>
    <app-control-pointer class="w-100"
      [controlPointer]="controlPointer"
      [colorComplete]="colorComplete"
      [colorIncomplete]="colorIncomplete"
      [colorPending]="colorPending"
      (selectPointer)="openAddCheckpointDialog($event)"
      (view)="openAddCheckpointDialog($event)"
      (addCheckpoint)="openAddCheckpointDialog($event)"
    ></app-control-pointer>
  }
</div>

